(function () {
    'use strict';

    angular.module("imApp").factory("bankReconciliationsAtService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3398,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
